// extracted by mini-css-extract-plugin
export default {"middle":"styles_middle__Re8EY","title":"styles_title__UMLKb","image":"styles_image__GbDvE","value_view":"styles_value_view__tHkp1","label":"styles_label__0doJB"};